import { DEFAULT_LOCALE, SDG_EXISTS_FOR_LANGUAGES, SDG_FALLBACK_LANGUAGE } from "@locales/locales-config"
import { BASE_URL } from "config"

export const PUBLIC_FOLDER_PATH = "public"
const SDG_FOLDER_PATH = "/assets/img/sdg/"

/**
 * Creates a valid path for the SDG-Images
 *
 * @param sdgId ID of the SDG
 * @param language the current locale to be used
 * @returns a valid path to the SDG-Image of the given SDG-ID
 */
export const sdgPathCreatorFunction = (sdgId: number, language: string): string => {

  if (!sdgId || sdgId < 1 || sdgId > 17 || !Number.isInteger(sdgId)) {
    return undefined
  }

  // #region file path structure
  const localePlaceholder = "[locale]"
  const sdgIdPlaceholder = "[id]"
  const pictureExtensionPlaceholder = "[extension]"
  // e.g. https://dev.api.projektfabrik.net/assets/img/sdg/en/sdg_icon_7.jpg
  const sdgImagePath = BASE_URL + SDG_FOLDER_PATH + localePlaceholder + "/sdg_icon_" + sdgIdPlaceholder + pictureExtensionPlaceholder
  // #endregion file path structure

  // #region constants
  const SDG_IMAGE_EXTENSION = ".jpg"
  // #endregion constants

  // get the given language or DEFAULT_LOCALE as fallback
  const currentLanguage = language || DEFAULT_LOCALE
  // choose the used language of the SDGs: use a fallback, if SDGs for the current language do not exist
  const sdgLanguage: string = SDG_EXISTS_FOR_LANGUAGES.includes(currentLanguage)
    ? currentLanguage
    : SDG_FALLBACK_LANGUAGE

  // replace all placeholders with values to get the full URL
  const sdgPath = sdgImagePath
    .replace(localePlaceholder, sdgLanguage)
    .replace(sdgIdPlaceholder, sdgId.toString())
    .replace(pictureExtensionPlaceholder, SDG_IMAGE_EXTENSION)

  return sdgPath
}
